
























































import {Component, Prop, Vue} from 'vue-property-decorator';
import axios from 'axios';

import {SERVER_HOST_QR} from '@/config';

@Component({
  name: "QrBadge"
})
export default class QrBadge extends Vue {
  @Prop({type: String, default: null}) show!: string | null
  @Prop({type: String, default: null}) params!: string | null
  item: any = {}

  TranslateType(str:string){
    let val:string = ''
    switch (str){
      case 'phone':
        val =  'Телефон'
        break;
      case 'email':
        val =  'Email'
        break;
      case 'site':
        val =  'Сайт'
        break;
    }
    return val
  }

  async getDataFromServer() {
    try {
      this.$emit('setLoading', true)
      const {data} = await axios.get(SERVER_HOST_QR + 'show/' + this.show + '/badge/' + this.params)
      if (data.status != 'err') {
        this.item = data
        this.$emit('addItemsFromStorage',
          {
            path: this.$route.path,
            obj: {
              type: 'badge',
              name: this.item.name.first + ' ' + this.item.name.last,
              company:data.companyTitle
            }
          }
        )
      } else {
        this.$emit('showError')
        console.log(data.errors[0].messages[0])
      }
    } catch (e) {
      console.log(e)
    }
  }

  mounted() {
    this.getDataFromServer()
  }

}
